export class Base64 {
  // constants
  
  constructor() {
    this.b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    this.re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    this.re_btou = new RegExp([
      '[\xC0-\xDF][\x80-\xBF]',
      '[\xE0-\xEF][\x80-\xBF]{2}',
      '[\xF0-\xF7][\x80-\xBF]{3}'
    ].join('|'), 'g');
    this.fromCharCode = String.fromCharCode;
    this.b64tab = {};
    const l = this.b64chars.length
    for (var i = 0; i < l; i++) this.b64tab[this.b64chars.charAt(i)] = i;
  }

  // encoder stuff
  cb_utob(c) {
    let fromCharCode = String.fromCharCode
    if (c.length < 2) {
      var cc = c.charCodeAt(0);
      return cc < 0x80 ? c
        : cc < 0x800 ? (fromCharCode(0xc0 | (cc >>> 6))
          + fromCharCode(0x80 | (cc & 0x3f)))
          : (fromCharCode(0xe0 | ((cc >>> 12) & 0x0f))
            + fromCharCode(0x80 | ((cc >>> 6) & 0x3f))
            + fromCharCode(0x80 | (cc & 0x3f)));
    } else {
      var cc = 0x10000
        + (c.charCodeAt(0) - 0xD800) * 0x400
        + (c.charCodeAt(1) - 0xDC00);
      return (fromCharCode(0xf0 | ((cc >>> 18) & 0x07))
        + fromCharCode(0x80 | ((cc >>> 12) & 0x3f))
        + fromCharCode(0x80 | ((cc >>> 6) & 0x3f))
        + fromCharCode(0x80 | (cc & 0x3f)));
    }
  };

  utob(u) {
    return u.replace(this.re_utob, this.cb_utob);
  };
  cb_encode(ccc) {
    var padlen = [0, 2, 1][ccc.length % 3],
      ord = ccc.charCodeAt(0) << 16
        | ((ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8)
        | ((ccc.length > 2 ? ccc.charCodeAt(2) : 0)),
      chars = [
        this.b64chars.charAt(ord >>> 18),
        this.b64chars.charAt((ord >>> 12) & 63),
        padlen >= 2 ? '=' : this.b64chars.charAt((ord >>> 6) & 63),
        padlen >= 1 ? '=' : this.b64chars.charAt(ord & 63)
      ];
    return chars.join('');
  };
  // decoder stuff
  cb_btou(cccc) {
    let fromCharCode = String.fromCharCode
    switch (cccc.length) {
      case 4:
        var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
          | ((0x3f & cccc.charCodeAt(1)) << 12)
          | ((0x3f & cccc.charCodeAt(2)) << 6)
          | (0x3f & cccc.charCodeAt(3)),
          offset = cp - 0x10000;
        return (fromCharCode((offset >>> 10) + 0xD800)
          + fromCharCode((offset & 0x3FF) + 0xDC00));
      case 3:
        return fromCharCode(
          ((0x0f & cccc.charCodeAt(0)) << 12)
          | ((0x3f & cccc.charCodeAt(1)) << 6)
          | (0x3f & cccc.charCodeAt(2))
        );
      default:
        return fromCharCode(
          ((0x1f & cccc.charCodeAt(0)) << 6)
          | (0x3f & cccc.charCodeAt(1))
        );
    }
  };

  btoa(b) {
    if (window.btoa) {
      return window.btoa(b);
    }
    return b.replace(/[\s\S]{1,3}/g, this.cb_encode);
  }
  _encode(u) { return this.btoa(this.utob(u)) }
  encode(u, urisafe) {
    return !urisafe
      ? this._encode(String(u))
      : this._encode(String(u)).replace(/[+\/]/g, function (m0) {
        return m0 == '+' ? '-' : '_';
      }).replace(/=/g, '');
  };
  encodeURI(u) { return this.encode(u, true) };

  btou(b) {
    return b.replace(this.re_btou, this.cb_btou);
  };
  cb_decode(cccc) {
    var len = cccc.length,
      padlen = len % 4,
      n = (len > 0 ? this.b64tab[cccc.charAt(0)] << 18 : 0)
        | (len > 1 ? this.b64tab[cccc.charAt(1)] << 12 : 0)
        | (len > 2 ? this.b64tab[cccc.charAt(2)] << 6 : 0)
        | (len > 3 ? this.b64tab[cccc.charAt(3)] : 0),
      chars = [
        this.fromCharCode(n >>> 16),
        this.fromCharCode((n >>> 8) & 0xff),
        this.fromCharCode(n & 0xff)
      ];
    chars.length -= [0, 0, 2, 1][padlen];
    return chars.join('');
  };

  atob(b) {
    if (window.atob) {
      return window.atob(b);
    }
    return b.replace(/[\s\S]{1,4}/g, this.cb_decode);
  }
  _decode(a) { return this.btou(this.atob(a)) }
  decode(a) {
    return this._decode(
      String(a).replace(/[-_]/g, function (m0) { return m0 == '-' ? '+' : '/' })
        .replace(/[^A-Za-z0-9\+\/]/g, '')
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/base64.js